import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e93a6c9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-data" }

import { useRouter } from 'vue-router'

import Button from 'primevue/button';


export default /*#__PURE__*/_defineComponent({
  __name: 'PolicyTextComponent',
  setup(__props) {

const router = useRouter()

function goBack() {
    router.go(-1);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (goBack()))
    }, "Предыдущий шаг"),
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(_unref(Button), {
      label: "Принять и продолжить",
      class: "form-button",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (goBack()))
    })
  ]))
}
}

})